import { useTranslation } from "react-i18next";
import iso2 from "../../assets/iso-2.png";

// Estado vacío del módulo "Iniciativas de IA" (spec 008, RF-19/CA-5). Se muestra únicamente cuando NO
// hay iniciativas registradas (distinto de "la búsqueda no arrojó resultados", CA-15, que se resuelve
// en IniciativasTable.jsx sin ocultar el buscador). El padre (views/IniciativasIA.jsx) es quien decide
// cuándo renderizar este componente en vez de la tabla + buscador + botón flotante.
const IniciativasEmptyState = ({ onCreate }) => {
  const [t] = useTranslation("iniciativasIA");

  return (
    <div className="text-center py-5">
      <img
        src={iso2}
        alt={t("iniciativasIA_empty_title")}
        className="img-fluid mb-3"
        style={{ maxWidth: "260px" }}
      />
      <h5 className="font-weight-bold">{t("iniciativasIA_empty_title")}</h5>
      <p className="text-muted">{t("iniciativasIA_empty_subtitle")}</p>
      <button type="button" className="brand-btn-action" onClick={onCreate}>
        <i className="fa fa-plus"></i>
        {t("iniciativasIA_btn_create")}
        <i className="fa fa-arrow-right"></i>
      </button>
    </div>
  );
};

export default IniciativasEmptyState;
